import { type UseMutationOptions, useMutation } from '@tanstack/react-query';
import type { APIError } from '@vizit/auth';
import {
  type StartAmazonVendorAuthorizationV1IntegrationsAmazonVendorAuthInitPostResponse,
  startAmazonVendorAuthorizationV1IntegrationsAmazonVendorAuthInitPost,
} from '../../generated';

export type AmazonVendorAuthInitMutation = StartAmazonVendorAuthorizationV1IntegrationsAmazonVendorAuthInitPostResponse;

export const useAmazonVendorAuthInitMutation = <TError = APIError, TContext = unknown>(
  options?: Omit<
    UseMutationOptions<AmazonVendorAuthInitMutation, TError, void, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) => {
  return useMutation<AmazonVendorAuthInitMutation, TError, void, TContext>({
    mutationKey: ['AmazonVendorAuthInit'],
    mutationFn: async () => {
      const { data } = await startAmazonVendorAuthorizationV1IntegrationsAmazonVendorAuthInitPost({
        throwOnError: true,
      });
      return data;
    },
    ...options,
  });
};
